<div [formGroup]="formGroup">
    <label [for]="controlName" class="form-control-label"
        >{{ label }}
        <span class="text-danger">{{ isRequired ? '*' : '' }}</span>
    </label>
    <textarea
        [id]="controlName"
        [formControlName]="controlName"
        [rows]="shape['rows']"
        [cols]="shape['cols']"
        class="form-control"
        [ngClass]="{
            'is-invalid':
                formControl.invalid &&
                (formControl.dirty || formControl.touched || changeText)
        }"></textarea>
    <div class="invalid-feedback">
        {{ messages?.invalid }}
    </div>
</div>
